window.dataLayer = window.dataLayer || [];

/**
 * 
 * @param {string} event 'add-to-cart'
 * @param {number} currentVariantID 2398128340928
 * @param {object} itemList // [{ product }, { product }]
 */
export function pushToCartEvent(event, currentVariantID, itemList) {
  const isProduct = itemList.variants ? true : false
  const isVariant = itemList.variants ? false : true
  const isList = itemList.length ? true : false
  let selectedProduct = itemList
  let selectedVariant
  // On PDP, this gets triggered during view_item && add_to_cart
  if (isProduct) {
    selectedVariant = selectedProduct.variants?.find(x => x.id == currentVariantID)
  }
  // If taking in a single product (e.g from currentProduct == {{ product.json }}
  if (isVariant && !isList) {
    selectedVariant = itemList
  }
  // If taking in an array of products (e.g window.theme.cartUpsellProducts)
  if (isList) {
    selectedProduct = itemList.find(product => product.variants.find(variant => variant.id === currentVariantID))
    selectedVariant = selectedProduct.variants?.find(x => x.id == currentVariantID)
  }
  // Calculate discount
  let discountPrice = 0
  if (selectedVariant?.compare_at_price != null) {
    discountPrice = Math.abs(((selectedVariant.compare_at_price - selectedVariant.price) / 100).toFixed(2))
  }
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: `${event}`,
    ecommerce: {
      currency: globalCartItems.currency,
      value: (selectedVariant?.price / 100).toFixed(2) || "",
      items: [
        {
          item_id: selectedVariant?.id || "",
          item_name: selectedProduct?.title || "",
          affiliation: "",
          coupon: "",
          discount: discountPrice || "",
          item_brand: selectedProduct?.vendor || "",
          item_category: selectedVariant?.option1 || "",
          item_category2: selectedVariant?.option2 || "",
          item_category3: selectedVariant?.option3 || "",
          item_category4: selectedVariant?.option4 || "",
          item_category5: selectedVariant?.option5 || "",
          item_list_id: selectedProduct?.collections?.first.handle || "",
          item_list_name: selectedProduct?.collections?.first.title || "",
          item_variant: selectedVariant?.title || "",
          location_id: "",
          price: (selectedVariant?.price / 100).toFixed(2) || "",
          quantity: 1
        }
      ]
    }
  })
}

// Helper Function
function convertPrices(price) {
  return (price/ 100).toFixed(2)
}

// Pushes all items in cart to dataLayer // [{ product },{ product },{ product }]
function beginCheckout() {
  const cart = globalCartItems
  const shopCurrency = cart.currency;;
  const cartTotalPrice = convertPrices(cart.total_price);
  const items = cart.items.map((item, index) => {
    return {
      item_id: item.id,
      item_name: item.title,
      itemPrice: convertPrices(item.discounted_price),
      affiliation: "",
      coupon: '',
      discount: convertPrices(item.original_price - item.discounted_price),
      item_brand: item.vendor,
      item_category: item.option1 || "",
      item_category2: item.option2 || "",
      item_category3: item.option3 || "",
      item_category4: item.option4 || "",
      item_category5: item.option5 || "",
      item_list_id: "", // TODO
      item_list_name: "",
      item_variant: item.variant_id,
      itemIndex : index + 1, // TODO
      itemQuantity: item.quantity
    };
  });

  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
      event:'ga_begin_checkout',
      ecommerce: {  
          value: cartTotalPrice, //10.00
          currency: shopCurrency,
          items: items
      }
  });
}

// Pushes collections page to dataLayer // Collection ID and Title
function collectionView() {
  const allProducts = allProductsOnPage // [{product},{product},{product}]
  const collection = currentCollectionPage
  const {
    title,
    id,
  } = collection
  const items = allProducts.map((item, index) => {
    // Logic to calculate product discount
    const discount = item.compare_at_price > 0 ? convertPrices(item.compare_at_price - item.price) : 0
    return {
      item_id: item.id,
      item_name: item.title,
      affiliation: "",
      coupon: '',
      discount: discount,
      item_brand: item.vendor,
      item_category: item.option1 || "",
      item_category2: item.option2 || "",
      item_category3: item.option3 || "",
      item_category4: item.option4 || "",
      item_category5: item.option5 || "",
      item_list_id: collection.id, // TODO
      item_list_name: collection.title,
      item_variant: item.variants[0].name,
      itemPrice: convertPrices(item.price),
      itemQuantity: item.quantity
    };
  });
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
      event:'ga_view_item_list',
      ecommerce: {
        item_list_id: id,
        item_list_name: title,
        items: items
      }
  });
}

export function addListenersToCheckoutButtons() {
  const checkoutButtons = document.querySelectorAll('a[href="/checkout"]')
  checkoutButtons.forEach( button => {
    button.addEventListener('click', (e) => { 
      beginCheckout()
    })
  })
}

export function ga4ProductView() {
  if (currentTemplateName === 'product') {
    pushToCartEvent('ga_view_item', currentVariantID, currentProduct);
  }
  if (currentTemplateName === 'collection') {
    collectionView()
  }
}